import { render } from "./ReportAndHideProjectCommentModal.vue?vue&type=template&id=364933dd"
import script from "./ReportAndHideProjectCommentModal.vue?vue&type=script&lang=js"
export * from "./ReportAndHideProjectCommentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__